import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/primitives/utils"

const textareaVariants = cva(
  "flex field-sizing-content w-full resize-none transition-[color,background-color,border-color,box-shadow] duration-100 ease-snappy outline-none placeholder:text-subtle-foreground disabled:cursor-not-allowed",
  {
    variants: {
      // beacon: the Input's metrics and states (surface, hairline, hover, focus halo, invalid), at
      // least 80px tall and growing with its content. `bare` has no chrome and inherits its font
      // size, as the Input's does, for a description typed in place (the New Project composer).
      variant: {
        default:
          "min-h-20 rounded-md border border-input bg-background px-2.5 py-2 text-ui shadow-none hover:border-border-strong focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/20 disabled:bg-muted disabled:text-muted-foreground aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/15 dark:bg-surface-sunken dark:disabled:bg-muted",
        bare: "min-h-0 rounded-md border-0 bg-transparent px-0 py-0 shadow-none ring-0 focus-visible:ring-0 disabled:text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

function Textarea({
  className,
  variant = "default",
  ...props
}: React.ComponentProps<"textarea"> & VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      data-variant={variant}
      className={cn(textareaVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Textarea, textareaVariants }
